<template>
  <vue-cookie-accept-decline
    element-id="weathermap"
    position="bottom"
    transition-name="slideFromBottom"
    type="bar"
    @clicked-accept="onAcceptCookies"
    @clicked-decline="onDeclineCookies"
    @clicked-postpone="onPostponeCookies"
    @removed-cookie="onRemovedCookie"
    @status="onCookieStatus"
  >
    <!-- Optional -->
    <template #postponeContent>&times;</template>

    <!-- Optional -->
    <template #message>
      {{ $t('cookies.message') }}
    </template>

    <!-- Optional -->
    <template #declineContent>{{ $t('cookies.reject') }}</template>

    <!-- Optional -->
    <template #acceptContent>{{ $t('cookies.accept') }}</template>
  </vue-cookie-accept-decline>
</template>

<script lang="ts">
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'

export default {
  name: 'CookieDisclaimer',

  components: {
    VueCookieAcceptDecline
  },

  data: () => ({}),

  methods: {
    onAcceptCookies() {
      console.log('Aceptadas cookies')
      if (this.$gtag) {
        // bootstrap().then(() => {
        //   // all done!
        // })
        this.$gtag.optIn()
      }
    },

    onDeclineCookies() {
      console.log('Denegadas cookies')
      if (this.$gtag) {
        this.$gtag.optOut()
      }
    },

    onPostponeCookies() {
      console.log('Postpone')
    },

    onRemovedCookie() {
      console.log('Removed')
    },

    onCookieStatus(evt: any) {
      if (evt === 'accept') {
        this.onAcceptCookies()
      } else {
        this.onDeclineCookies()
      }
    }
  }
}
</script>

<style lang="scss">
@import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';

$breakpoint: 768px;

.cookie.cookie__bar {
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;

  * {
    font-family: inherit;
  }
  .cookie__bar__wrap {
    width: auto;
    display: flex;
    gap: 1rem;

    @media (min-width: $breakpoint) {
      gap: 3rem;
    }

    .cookie__bar__content {
      max-width: 600px;
      margin: 0;
      text-align: justify;
      text-align-last: left;

      @media (min-width: $breakpoint) {
        text-align: justify;
        text-align-last: left;
      }
    }

    .cookie__bar__buttons {
      width: inherit;

      .cookie__bar__buttons__button {
        font-weight: 500;
        border-radius: 1rem;
        border: 2px solid var(--vx-primary);

        &.cookie__bar__buttons__button--accept {
          background: var(--vx-primary);
          color: var(--vx-accent);
        }

        &.cookie__bar__buttons__button--decline {
          background: white;
          color: var(--vx-primary);
        }
      }
    }
  }
}
</style>
